import React, { useContext, useState, useMemo } from 'react';
import { CarritoContext } from '../context/CarritoContext';
import Checkout from './Checkout';
import '../styles/Carrito.css';

const Carrito = ({ onCerrar }) => {
  const [mostrarCheckout, setMostrarCheckout] = useState(false);
  const {
    productosCarrito,
    tipoEntrega,
    eliminarProducto,
    cambiarCantidad,
    cambiarTipoEntrega,
    calcularSubtotal,
    calcularCostoEnvio,
    calcularTotal,
  } = useContext(CarritoContext);

  // Validar que los productos tengan las propiedades necesarias
  // useMemo evita recalcular en cada render si productosCarrito no cambia
  const productosValidos = useMemo(() => {
    return productosCarrito.filter(producto =>
      producto && producto._id && producto.nombre && typeof producto.precio === 'number' && producto.cantidad
    );
  }, [productosCarrito]);

  // Si mostrar checkout está activo, renderizar el componente Checkout
  if (mostrarCheckout) {
    return (
      <Checkout
        onVolver={() => setMostrarCheckout(false)}
        productosValidos={productosValidos}
        tipoEntrega={tipoEntrega}
        total={calcularTotal()}
      />
    );
  }

  if (productosValidos.length === 0) {
    return (
      <div className="carrito-container">
        <div className="carrito-header">
          <h2>🛒 Carrito de Compras</h2>
          <button className="btn-cerrar-carrito" onClick={onCerrar}>✕</button>
        </div>
        <div className="carrito-vacio">
          <p>Tu carrito está vacío</p>
          <button className="btn-volver" onClick={onCerrar}>Volver a productos</button>
        </div>
      </div>
    );
  }

  return (
    <div className="carrito-container">
      <div className="carrito-header">
        <h2>🛒 Carrito de Compras</h2>
        <button className="btn-cerrar-carrito" onClick={onCerrar}>✕</button>
      </div>

      <div className="carrito-contenido">
        {/* Lista de productos */}
        <div className="carrito-productos">
          <h3>Productos ({productosValidos.length})</h3>
          <div className="productos-lista">
            {productosValidos.map((producto) => (
              <div key={producto._id} className="carrito-item">
                <img 
                  src={producto.imagen || 'https://via.placeholder.com/80'} 
                  alt={producto.nombre}
                  className="carrito-item-imagen"
                  onError={(e) => {
                    e.target.src = 'https://via.placeholder.com/80';
                  }}
                />
                <div className="carrito-item-detalles">
                  <h4>{producto.nombre}</h4>
                  <p className="carrito-item-precio">${producto.precio}</p>
                </div>
                <div className="carrito-item-cantidad">
                  <button 
                    onClick={() => cambiarCantidad(producto._id, producto.cantidad - 1)}
                    className="btn-cantidad"
                  >
                    −
                  </button>
                  <span>{producto.cantidad}</span>
                  <button 
                    onClick={() => cambiarCantidad(producto._id, producto.cantidad + 1)}
                    className="btn-cantidad"
                  >
                    +
                  </button>
                </div>
                <div className="carrito-item-subtotal">
                  ${(producto.precio * producto.cantidad).toLocaleString()}
                </div>
                <button 
                  onClick={() => eliminarProducto(producto._id)}
                  className="btn-eliminar"
                  title="Eliminar del carrito"
                >
                  🗑️
                </button>
              </div>
            ))}
          </div>
        </div>

        {/* Opciones de entrega */}
        <div className="carrito-entrega">
          <h3>Tipo de Entrega</h3>
          <div className="opciones-entrega">
            <label className={`opcion-entrega ${tipoEntrega === 'retiro' ? 'activo' : ''}`}>
              <input
                type="radio"
                name="entrega"
                value="retiro"
                checked={tipoEntrega === 'retiro'}
                onChange={(e) => cambiarTipoEntrega(e.target.value)}
              />
              <span>🏪 Retiro por el local</span>
              <span className="costo">GRATIS</span>
            </label>
            <label className={`opcion-entrega ${tipoEntrega === 'envio' ? 'activo' : ''}`}>
              <input
                type="radio"
                name="entrega"
                value="envio"
                checked={tipoEntrega === 'envio'}
                onChange={(e) => cambiarTipoEntrega(e.target.value)}
              />
              <span>🚚 Envío a domicilio</span>
              <span className="costo">$5.000</span>
            </label>
          </div>
        </div>

        {/* Resumen de pago */}
        <div className="carrito-resumen">
          <h3>Resumen</h3>
          <div className="resumen-linea">
            <span>Subtotal:</span>
            <span>${calcularSubtotal().toLocaleString()}</span>
          </div>
          {tipoEntrega === 'envio' && (
            <div className="resumen-linea">
              <span>Envío:</span>
              <span>${calcularCostoEnvio().toLocaleString()}</span>
            </div>
          )}
          <div className="resumen-total">
            <span>Total:</span>
            <span>${calcularTotal().toLocaleString()}</span>
          </div>
          <button 
            className="btn-checkout" 
            onClick={() => setMostrarCheckout(true)}
          >
            Proceder al Pago
          </button>
          <button className="btn-continuar-comprando" onClick={onCerrar}>Continuar Comprando</button>
        </div>
      </div>
    </div>
  );
};

export default Carrito;
